export default __webpack_public_path__ + "static/media/PitcherAngle-LeftHandPitcher.50fe655f.png";